var _style, _defs, _defs2, _defs3, _g, _defs4, _defs5, _defs6, _g2, _defs7, _defs8, _defs9, _g3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendContactCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.8 17.9",
    style: {
      enableBackground: "new 0 0 21.8 17.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{clip-path:url(#SVGID_6_);}\n\t.st3{fill:none;stroke:#1D3152;stroke-width:1.8;stroke-miterlimit:10;}\n\t.st4{clip-path:url(#SVGID_8_);}\n\t.st5{clip-path:url(#SVGID_10_);}\n\t.st6{clip-path:url(#SVGID_12_);}\n\t.st7{fill:none;stroke:#1D3152;stroke-width:1.64;stroke-miterlimit:10;}\n\t.st8{clip-path:url(#SVGID_14_);}\n\t.st9{clip-path:url(#SVGID_16_);}\n\t.st10{clip-path:url(#SVGID_18_);}\n\t.st11{fill:none;stroke:#1D3152;stroke-width:1.03;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#1D3152;stroke-width:0.51;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M6.4,1.7h9c1.7,0,3,1.3,3,3v8.5c0,1.7-1.3,3-3,3h-9c-1.7,0-3-1.3-3-3V4.7C3.4,3,4.7,1.7,6.4,1.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -6.6,
    y: -7.3,
    width: 34,
    height: 33
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 3.4,
    y: 1.7,
    width: 15,
    height: 15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.4,1.7h9c1.7,0,3,1.3,3,3v8.5c0,1.7-1.3,3-3,3h-9c-1.7,0-3-1.3-3-3V4.7C3.4,3,4.7,1.7,6.4,1.7z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_7_",
    cx: 10.9,
    cy: 8.9,
    r: 4.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -2.6,
    y: -4.3,
    width: 27,
    height: 26
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 6.4,
    y: 3.7,
    width: 9,
    height: 10
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 10.9,
    cy: 8.9,
    r: 4.3
  }))))))))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_13_",
    cx: 10.8,
    cy: 8.3,
    r: 1.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 3.4,
    y: 0.7,
    width: 15,
    height: 15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 8.4,
    y: 5.7,
    width: 5,
    height: 5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 10.8,
    cy: 8.3,
    r: 1.6
  }))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M8.4,11.9c0-0.9,0.8-1.6,1.7-1.6h1.5c0.9,0,1.7,0.7,1.7,1.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendContactCard);
export default __webpack_public_path__ + "static/media/send-contact-card.f01127550a7a2914f294465205ae42fb.svg";
export { ForwardRef as ReactComponent };